import { render, staticRenderFns } from "./TopCampaigns.vue?vue&type=template&id=03f2e5b2&scoped=true"
import script from "./TopCampaigns.vue?vue&type=script&lang=js"
export * from "./TopCampaigns.vue?vue&type=script&lang=js"
import style0 from "./TopCampaigns.vue?vue&type=style&index=0&id=03f2e5b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f2e5b2",
  null
  
)

export default component.exports